import React, { useState, useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

import CalendarComponent from "./space-detail-calendar";
import { fetchSpaceToCalendar } from "../redux/actions/spaceAction";
import { useAppDispatch } from "../redux/hook";

import "../../node_modules/react-modal-video/css/modal-video.css";

export default function SpaceDetail() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [spaceData, setSpaceData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSpace = async () => {
      const space = await dispatch(fetchSpaceToCalendar());

      if (typeof space.payload === "string") {
        setLoading(false);
        // navigate(checkError(homeEdit.payload));
      } else {
        setLoading(false);
        setSpaceData(space.payload);
      }
    };
    loadSpace();
  }, [dispatch]);

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className="container relative">
      <div className="grid grid-cols-1 lg:grid-cols-12 md:grid-cols-2 gap-10">
        <div className="lg:col-span-5">
          <div className="relative">
            <CalendarComponent events={spaceData} />
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="lg:ms-7">
            <h3 className="mb-4 md:text-2xl text-xl font-medium">
              {t("external.space.calendar_of_association")}
            </h3>

            <p className="text-slate-400 dark:text-white/60 max-w-2xl mx-auto">
              {t("external.space.text")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
